import { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import Hero from '../components/home/Hero';
import ServiceTimes from '../components/home/ServiceTimes';
import FeaturedAnnouncements from '../components/home/FeaturedAnnouncements';
import CurrentTeaching from '../components/home/CurrentTeaching';
import ConnectSection from '../components/home/ConnectSection';

export default function Home() {
  const [currentSeries, setCurrentSeries] = useState(null);
  const [announcements, setAnnouncements] = useState([]);
  const [catechism, setCatechism] = useState(null);
  const [homePageData, setHomePageData] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch all homepage data in parallel
        const [seriesRes, announcementsRes, catechismRes, homepageRes, settingsRes] = await Promise.allSettled([
          apiService.getCurrentSeries(),
          apiService.getFeaturedAnnouncements(3),
          apiService.getWeeklyCatechism(),
          apiService.getHomepage(),
          apiService.getSettings(),
        ]);

        if (seriesRes.status === 'fulfilled') {
          setCurrentSeries(seriesRes.value.data);
        }

        if (announcementsRes.status === 'fulfilled') {
          setAnnouncements(announcementsRes.value.data);
        }

        if (catechismRes.status === 'fulfilled') {
          setCatechism(catechismRes.value.data);
        }

        if (homepageRes.status === 'fulfilled') {
          setHomePageData(homepageRes.value.data);
          setSettings(settingsRes.value.data);
        }
      } catch (error) {
        console.error('Error fetching homepage data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  
  return (
    <main id="main-content">
      <Hero
        currentSeries={currentSeries}
        heroSlides={homePageData?.heroSlides}
        showScrollIndicator={settings?.show_service_times !== false}
      />
      {settings?.show_service_times !== false && (
        <ServiceTimes
          serviceTimes={homePageData?.serviceTimes}
          location={homePageData?.location}
          settings={settings}
        />
      )}
      <FeaturedAnnouncements
        announcements={announcements}
        loading={loading}
      />
      <CurrentTeaching
        catechism={catechism}
        loading={loading}
      />
      <ConnectSection
        connectCards={homePageData?.connectCards}
      />
      {(settings?.app_link_apple || settings?.app_link_google || settings?.app_link_amazon) && (
        <div className="w-full bg-gray-100 py-12">
          <div className="container-wide p-8">
            <h2 className="text-headline text-4xl text-center mb-4">Download the CGS App</h2>
            <div className="bg-white rounded-lg shadow-lg p-8 flex items-center justify-center">
              {settings.app_link_apple ? (
                <a href={settings.app_link_apple} title={settings.app_title_apple || 'Apple App Store'} className="ml-4 text-lg font-semibold text-primary hover:text-accent transition-colors" target="_blank" rel="noreferrer">
                  <img src={settings.app_image_apple || 'https://dashboard.static.subsplash.com/production/web-client/images/store-itunes-black-b8a7cdd6913bb18e1979aba501c98fb1.svg'} alt={settings.app_title_apple || 'Apple App Store'}/>
                </a>
              ) : null}
              {settings.app_link_google ? (
                <a href={settings.app_link_google} title={settings.app_title_google || 'Google Play Store'} className="ml-4 text-lg font-semibold text-primary hover:text-accent transition-colors" target="_blank" rel="noreferrer">
                  <img src={settings.app_image_google || 'https://dashboard.static.subsplash.com/production/web-client/images/store-google-play-e6025e6c93787f1264323c6c1672721d.svg'} alt={settings.app_title_google || 'Google Play Store'}/>
                </a>
              ) : null}
              {settings.app_link_amazon ? (
                <a href={settings.app_link_amazon} title={settings.app_title_amazon || 'Amazon App Store'} className="ml-4 text-lg font-semibold text-primary hover:text-accent transition-colors" target="_blank" rel="noreferrer">
                  <img src={settings.app_image_amazon || 'https://dashboard.static.subsplash.com/production/web-client/images/store-amazon-black-96b53c124b9f6dca5cbd88063c1e31ad.svg'} alt={settings.app_title_amazon || 'Amazon App Store'}/>
                </a>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </main>
  );
}
